import { render, staticRenderFns } from "./Hero5Demo.vue?vue&type=template&id=7ab42072&"
import script from "./Hero5Demo.vue?vue&type=script&lang=js&"
export * from "./Hero5Demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports